import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'BoltSwap',
  description:
    'The most popular AMM on BSC by user count! Earn BOLT through yield farming or win it in the Lottery, then stake it in Syrup Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by BoltSwap), NFTs, and more, on a platform you can trust.',
  image: 'https://boltswap.io/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `BoltSwap`,
      }
    case '/swap':
      return {
        title: `${t('BoltSwap')} - ${t('Swap')}`,
      }
    case '/add':
      return {
        title: `${t('BoltSwap')} - ${t('Add Liquidity')}`,
      }
    case '/remove':
      return {
        title: `${t('BoltSwap')} - ${t('Remove Liquidity')}`,
      }
    case '/liquidity':
      return {
        title: `${t('BoltSwap')} - ${t('Liquidity')}`,
      }
    case '/find':
      return {
        title: `${t('Import Pool')} | ${t('BoltSwap')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('BoltSwap')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('BoltSwap')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `${t('Leaderboard')} | ${t('BoltSwap')}`,
      }
    case '/farms':
      return {
        title: `${t('BoltSwap')} - ${t('Farms')}`,
      }
    case '/farms/auction':
      return {
        title: `${t('Farm Auctions')} | ${t('BoltSwap')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('BoltSwap')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('BoltSwap')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('BoltSwap')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('BoltSwap')}`,
      }
    case '/voting':
      return {
        title: `${t('Voting')} | ${t('BoltSwap')}`,
      }
    case '/voting/proposal':
      return {
        title: `${t('Proposals')} | ${t('BoltSwap')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `${t('Make a Proposal')} | ${t('BoltSwap')}`,
      }
    case '/info':
      return {
        title: `${t('Overview')} | ${t('BoltSwap Info & Analytics')}`,
        description: 'View statistics for BoltSwap exchanges.',
      }
    case '/info/pools':
      return {
        title: `${t('Pools')} | ${t('BoltSwap Info & Analytics')}`,
        description: 'View statistics for BoltSwap exchanges.',
      }
    case '/info/tokens':
      return {
        title: `${t('Tokens')} | ${t('BoltSwap Info & Analytics')}`,
        description: 'View statistics for BoltSwap exchanges.',
      }
    case '/nfts':
      return {
        title: `${t('Overview')} | ${t('BoltSwap')}`,
      }
    case '/nfts/collections':
      return {
        title: `${t('Collections')} | ${t('BoltSwap')}`,
      }
    case '/nfts/profile':
      return {
        title: `${t('Your Profile')} | ${t('BoltSwap')}`,
      }
    default:
      return null
  }
}
